import React, { useEffect, useState, useRef, memo } from "react";
import { DragDropContext } from "react-beautiful-dnd";
import classNames from "classnames";
import { FormattedMessage } from "react-intl";

import "./style.scss";

import Product from "components/Product";
import Dices from "components/Dices";
import Preloader from "components/Preloader";
import Options from "../../components/Options/Options.component";
import Intro from "../../components/Intro";
// import DefaultSlider from "../../components/DefaultSlider";
import Sugestions from "../../components/Suggestions";

import CookieService from "../../services/CookieService";

import { useMainContext } from "../../store/Context";

// import { BANNER, BANNER_MOBILE } from "../../components/DefaultSlider";

const App = () => {
  const {
    isMobile,
    product,
    getItemHeight,
    getDicesFromCategory,
    getDice,
    setShowAlert,
    removeDice,
    diceSelected,
    reorderDices,
    showAlert,
    alertMessage,
  } = useMainContext();
  const [showIntro, setShowIntro] = useState(false);

  const productDisplayRef = useRef(null);

  const move = (source, destination, droppableDestination) => {
    const destClone = Array.from(destination);
    destClone.splice(droppableDestination.index, 0, source);
    return destClone;
  };

  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };

  const getWidth = (target) => {
    return !isMobile
      ? `${target}px`
      : `${(100 / window.innerWidth) * target}vw`;
  };

  const calculateTop = (mode) => {
    let height = -120;
    product.dices.forEach((dice, index) => {
      height += getItemHeight(dice);
    });
    const strap = document.querySelector(".Strap__Small");
    strap.style.top = getWidth(height);
  };

  const onDragStart = (result) => {
    const el = document.querySelector(".Dices");
    if (el) el.style.zIndex = "17";
    const resultFormated = result.draggableId.split("-");
    if (result.source.droppableId === "dices") {
      const type = resultFormated[0];
      const diceIndex = parseInt(resultFormated[1], 10);
      const diceSelected = getDicesFromCategory(type)[diceIndex];

      getDice(diceSelected);
    }
    if (
      result.source.droppableId === "strap" &&
      resultFormated[0] !== "anagram"
    ) {
      const diceSelected = getDicesFromCategory(resultFormated[0]).find(
        (item) => item.id === resultFormated[1]
      );
      getDice(diceSelected);
    }
  };

  const onDragEnd = (result) => {
    const el = document.querySelector(".Dices");
    if (el) el.style.zIndex = "10";
    const { source, destination } = result;

    if (source.droppableId === "strap" && !destination) {
      if (product.dices[source.index].is_anagram) {
        setShowAlert(1);
        return;
      } else {
        removeDice(source.index);
        calculateTop("deacrease");
        return;
      }
    }

    if (!destination) {
      return;
    }

    const droppableIdIsDices = destination.droppableId === "dices";

    switch (destination.droppableId) {
      case "strap":
        const hasMoreThanTwoLetterLetters =
          product.dices.reduce(
            (total, { category_type }) =>
              category_type === "leatherletter" ? total + 1 : total,
            0
          ) >= 2;

        if (
          hasMoreThanTwoLetterLetters &&
          droppableIdIsDices &&
          diceSelected.category_type === "leatherletter"
        ) {
          setShowAlert(2);
          return;
        }

        if (product.dices.length >= 6 && droppableIdIsDices) {
          setShowAlert(0);
          return;
        }

        if (source.droppableId !== destination.droppableId) {
          const items = move(diceSelected, product.dices, destination);
          reorderDices(items);
          calculateTop("add");
          return;
        }

        const items = reorder(product.dices, source.index, destination.index);
        reorderDices(items);
        break;
      case "trash":
        if (
          !droppableIdIsDices &&
          source.droppableId === "strap" &&
          product.dices[source.index] &&
          product.dices[source.index].is_anagram
        ) {
          setShowAlert(1);
          return;
        }
        if (source.droppableId === "strap") {
          removeDice(source.index);
          calculateTop("deacrease");
          return;
        }
        break;
      default:
        break;
    }
  };

  const showApp = true || window.location.hash === "#app" ? true : false;

  const alertClasses = classNames("Product__alert", {
    active: showAlert,
  });

  const handlerDoneIntro = () => {
    CookieService.setCookie("intro", true);
    setShowIntro(false);
  };

  const onSelectPreset = () => {
    productDisplayRef.current.scrollIntoView({
      behavior: "smooth",
    });
  };

  useEffect(() => {
    setShowIntro(CookieService.getCookie("intro") ? false : true);
    document.body.style.margin = 0;
  }, []);

  return (
    <div className="App">
      <div className="App__banner" />

      {showIntro && <Intro onDone={handlerDoneIntro} />}

      <Preloader />

      <div className="App__heading">
        <div className="App__title">
          <FormattedMessage id="App.title" />
        </div>
        <div className="App__description">
          <FormattedMessage id="App.description" />
        </div>
      </div>

      {showApp && (
        <div className="App__wrapper">
          <div className="App__wrapper-items">
            <div className={alertClasses}>
              <FormattedMessage
                id={alertMessage ? alertMessage : "Alert.anagram"}
              />
            </div>
            <DragDropContext onDragStart={onDragStart} onDragEnd={onDragEnd}>
              <Dices />
              <div className="App-WrapProduct" ref={productDisplayRef}>
                <Product />
              </div>
              <Options />
            </DragDropContext>
          </div>

          <Sugestions onSelectPreset={onSelectPreset} />

          {/*<div className="App__extra__container">*/}
          {/*  <div className="App__carousel">*/}
          {/*    <DefaultSlider*/}
          {/*      itemClassName={"App__carousel-item"}*/}
          {/*      type={isMobile ? BANNER_MOBILE : BANNER}*/}
          {/*    />*/}
          {/*  </div>*/}
          {/*  <div className="App__heading App__heading__bottom">*/}
          {/*    <div className="App__title">*/}
          {/*      <FormattedMessage id="App.perfectGift" />*/}
          {/*    </div>*/}
          {/*    <div className="App__description App__description__bottom">*/}
          {/*      <FormattedMessage id="App.perfectText" />*/}
          {/*    </div>*/}
          {/*    <div className="App__description App__description__stores">*/}
          {/*      <FormattedMessage id="App.stores" />*/}
          {/*    </div>*/}
          {/*    <a href="https://www.loewe.com/eur/en/stores/personalisation-tool.html">*/}
          {/*      <span className="App__link">*/}
          {/*        <FormattedMessage id="App.access" />*/}
          {/*      </span>*/}
          {/*    </a>*/}
          {/*  </div>*/}
          {/*</div>*/}
        </div>
      )}
    </div>
  );
};
export default memo(App);
